import { HoldStatusesArray } from '../responses/hold.statistics.item';

export class HoldStatsRequest {
    HoldStatuses: HoldStatusesArray;
    StartDate?: Date;
    EndDate?: Date;
}
